// This file was generated with `npm run icons:generate`. Don’t edit directly.
import Icon from 'tailwind/components/Icon/Icon';
import type { SmallIconProps } from 'tailwind/components/Icon/Icon.types';

const UtilityStrokeNotificationSmallIcon = (props: SmallIconProps) => (
  <Icon {...props} viewBox="0 0 16 16">
    <path
      d="M7.99967 2.89591C6.27379 2.89591 4.87467 4.29503 4.87467 6.02091V9.22289C4.87467 9.57878 4.70603 9.93279 4.39131 10.099C4.06009 10.2739 3.83301 10.6222 3.83301 11.0209C3.83301 11.5938 4.30176 12.0626 4.87467 12.0626H11.1247C11.6976 12.0626 12.1663 11.5938 12.1663 11.0209C12.1663 10.6222 11.9393 10.2739 11.608 10.099C11.2933 9.93279 11.1247 9.57878 11.1247 9.22289V6.02091C11.1247 4.29503 9.72556 2.89591 7.99967 2.89591ZM7.99967 2.89591L7.99967 1.85425M6.95801 14.1459H9.04134"
      stroke="currentcolor"
      strokeWidth="0.8"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export default UtilityStrokeNotificationSmallIcon;
